var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelegationIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 32,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-180 32.5 32)",
    fill: "#2B2A28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C09663",
    d: "M12.5 6.631h8v5h-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#504E4C",
    d: "M20.5 25.63h-8v-5h8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#996939",
    d: "M6.5 9.631h8v5h-8zM6.5 9.63h-2v-2h2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#504E4C",
    d: "M6.5 24.63h-2v-2h2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09663",
    d: "M28.5 9.63h-2v-2h2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#434242",
    d: "M28.5 24.63h-2v-2h2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09663",
    d: "M2.5 14.631h5v3h-5zM25.5 14.631h5v3h-5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#434342",
    d: "M26.5 22.63h-8v-5h8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C09663",
    d: "M18.5 9.631h8v5h-8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#504E4C",
    d: "M14.5 22.63h-8v-5h8z"
  })));
};
export default SvgDelegationIcon;